import { render } from "./InvestorProjects.vue?vue&type=template&id=3346ca7e"
import script from "./InvestorProjects.vue?vue&type=script&lang=js"
export * from "./InvestorProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__